import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { handleTokenRefreshed } from '../data/coreActions';
import { post } from '../utils/ajax';
import { remoteRoutes, AUTH_REFRESH_TOKEN_KEY } from '../data/constants';

// Access tokens live 20 minutes; refreshing every 15 leaves a safe buffer
// so an active user's token never actually expires mid-session. If the
// refresh token itself is invalid/expired (12h absolute cap, or a newer
// login elsewhere bumped tokenVersion), the request 401s and the default
// error handling in ajax.ts already clears storage and redirects to
// login — no special handling needed here for that case.
const REFRESH_INTERVAL_MS = 15 * 60 * 1000;

export function useTokenRefresh(enabled: boolean) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled) return undefined;

    const refresh = () => {
      const refreshToken = localStorage.getItem(AUTH_REFRESH_TOKEN_KEY);
      if (!refreshToken) return;
      post(remoteRoutes.refreshToken, { refreshToken }, (data: any) => {
        if (data?.token) dispatch(handleTokenRefreshed(data.token));
      });
    };

    const interval = setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [enabled, dispatch]);
}
